module.exports = __webpack_public_path__ + "static/hobbyistPic-2648ebdf72c42cb4da456a78f7ee1fd5.png";